export default __webpack_public_path__ + "static/salesforce-partner-25a184b4495fd355233814205dc92923.png";